import { adminJson } from './adminJson';
import type { BusinessSetupResponse, ZoneRankingsResponse } from '@/types/rankings';

/**
 * Consolidated ranking payload (DashboardStatsJsonController@zone).
 * Server ranking: order_count / wishlist count / rating_count / orders_count — no client recompute.
 */
export function fetchDashboardRankings(zoneId: string | number = 'all') {
  return adminJson<ZoneRankingsResponse>('/admin/dashboard-stats-json/zone', {
    method: 'POST',
    body: JSON.stringify({ zone_id: zoneId }),
  });
}

/** Real business name / footer text / software version. */
export function fetchBusinessFooter() {
  return adminJson<BusinessSetupResponse>('/admin/json-compat/settings/business-setup');
}
